import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterTabs = ({ activeFilter, onFilterChange, counts }) => {
  const filters = [
    { id: 'all', label: 'All', icon: 'Bell', count: counts?.all || 0 },
    { id: 'campaign', label: 'Campaigns', icon: 'Briefcase', count: counts?.campaign || 0 },
    { id: 'message', label: 'Messages', icon: 'MessageSquare', count: counts?.message || 0 },
    { id: 'payment', label: 'Payments', icon: 'DollarSign', count: counts?.payment || 0 },
    { id: 'proposal', label: 'Proposals', icon: 'FileText', count: counts?.proposal || 0 },
  ];

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      {filters?.map((filter) => (
        <button
          key={filter?.id}
          onClick={() => onFilterChange?.(filter?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap ${
            activeFilter === filter?.id
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          <Icon name={filter?.icon} size={16} />
          <span>{filter?.label}</span>
          {filter?.count > 0 && (
            <span
              className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                activeFilter === filter?.id
                  ? 'bg-primary-foreground/20 text-primary-foreground'
                  : 'bg-primary/10 text-primary'
              }`}
            >
              {filter?.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;